import {Formik, ErrorMessage, Form, Field} from 'formik'
import React, {useEffect, useMemo, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl, useDebounce} from '../../../../../_metronic/helpers'

import {GeneralDataOFLoginUser} from '../../../../Utils/Auth'
import {UserAccountSchema} from '../../../../Utils/_helpers/ValidationSchema'
import {
  GetAllStaff,
} from '../../MyProfile/Staff_Account/StaffAccountSlice/StaffAccountSlice'
import {
  AccountTypeOptions,
  IndustryOptions,
  SelectFeature,
} from '../Constant/CellCastConstant'
import {
  CreateUserAccount,
  getAccountIdList,
  UpdateUserAccount,
} from '../UserListSlice/UserListSlice'
import Select, {components, MenuListProps} from 'react-select'
import {useGetGatewayProviderQuery} from '../../../../../services/cellcast'
import TagPopupModal from '../../../UserPages/Contacts/AllContactsList/Modal/TagPopupModal'
import { getalltagsdata } from '../../../UserPages/Contacts/Tags/TagSlice/TagsSlices'


const CreateUserAccountPopup = ({show, handleClose, data, filter, page}: any) => {
  //////////////////////////////ALL CONSTANT//////////////////////////
  const param: any = useLocation()
  const dispatch = useDispatch()
  const isUserWhiteLabel = GeneralDataOFLoginUser()?.isWhiteLabelUser === false
  const accountIdPass = GeneralDataOFLoginUser()
  const [openTagPopup, setOpenTagPopup] = useState(false)
  const [tags, setTags] = useState<any>([])
  const tagslist = useSelector((state: any) => state?.tags?.allTags?.data)

  const {data: provider} = useGetGatewayProviderQuery(null)

  const providerList = [
    {
      value: "",
      label: "Default Provider",
      type: "default",
    },
    ...(provider?.data?.map((it: any) => ({
      value: it?.gatewayConfig?.name,
      label: `${it?.DB}-${it?.gatewayName}`,
      type: it?.type?.toLowerCase(),
    })) ?? []),
  ];

  ////////////////////////USESTATE/////////////////////////////////////////
  const [pageSearch, setPageSearch] = useState({
    page: 1,
    size: 10,
    search: '',
  })
  const [user, setUserData] = useState<any>({
    avatar: '',
    email: '',
    mobile: '',
    name: '',
    website: '',
    password: '',
    accountManager: '',

    accountType: 'prepaid',
    smsGateway: '',
    mmsGateway: '',
    sales: '',
    role: '',
    companyName: '',
    industry: '',
    features: [],
    notes: '',
    accountId: accountIdPass?.accountId,
    editting: false,
    defaultCoupon: '',
    tags: []
  })

  const [passwordType, setPasswordType] = useState({
    password: true,
  })

  ////////////////////////////////////USE SELECTOR/////////////////////////////////
  const stafflist = useSelector((state: any) => state?.StaffAccount?.staffAccountList)
  const accountIdList = useSelector(getAccountIdList)
  const debouncedSearchTerm = useDebounce(pageSearch?.search, 500)

  useEffect(() => {
    dispatch(getalltagsdata())
    setPasswordType({
      password: true,
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show])

  useEffect(() => {
    if (data !== undefined) {
      const feature = data?.features
      setUserData({
        ...user,
        ...{
          website: data?.companyWebsite,
          accountManager: data?.accountManager,
          accountType: data?.accountType,
          sales: {
            value: data?.sales?._id,
            label: data?.sales?.name
          },
          features: feature,
          avatar: data?.avatar,
          email: data?.email,
          mobile: data?.mobile,
          name: data?.name,
          role: data?.role,
          isoCode: 'au',
          companyName: data?.companyName,
          industry: data?.industry,
          notes: data?.notes,
          accountId: data?.accountId,
          editting: true,
          smsGateway: data?.defaultGateway?.sms,
          mmsGateway: data?.defaultGateway?.mms,
          defaultCoupon: data?.defaultCoupon,
          tags: data.tags?.map((item: any) => {
            return {
              label: item?.name,
              value: item?._id
            }
          }) ?? []
        },
      })
    } else {
      let getAccountId = accountIdList?.find((key: any) => key?.companyName === 'cellcast')
      if (isUserWhiteLabel) {
        setUserData({
          ...user,
          accountId: getAccountId?._id,
        })
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, data])

  useEffect(() => {
    dispatch(GetAllStaff({page: pageSearch}))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchTerm])

  const acc = stafflist?.items
    ?.filter((key: any) => key?.role === 'accountManager')
    ?.map((val: any) => ({value: val?._id, label: val?.name}))
  const saleopt = stafflist?.items?.filter(
    (key: any) => key?.role === 'sales' || key?.role === 'staffAdmin'
  )

  const AddTagPopup = useMemo(
    () => (
      <TagPopupModal
        selectedTag={user?.tags}
        isAdmin={true}
        show={openTagPopup}
        handleClose={() => {
          setOpenTagPopup(false)
        }}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [openTagPopup]
  )

  const MenuList = (props: MenuListProps<any>) => {
    return (
      <components.MenuList {...props}>
        {props.children}
        <div
          style={{
            width: '100%',
            display: 'flex',
            gap: '6px',
            cursor: 'pointer',
            alignItems: 'center',
            justifyContent: 'center',
            borderTop: '1px solid #F4F5F7',
            paddingTop: '10px',
          }}
          onClick={() => {
            setOpenTagPopup(true)
          }}
        >
          <i
            style={{
              color: '#7950F2',
              fontWeight: 'bold !important',
            }}
            className='bi bi-plus-lg'
          ></i>
          <p
            style={{
              color: '#7950F2',
              margin: 0,
              fontWeight: 600,
            }}
          >
            Create new
          </p>
        </div>
      </components.MenuList>
    )
  }

  useEffect(() => {
    const filteredTags = tagslist?.filter((val: any) => {
      if (val?.type) {
        return val?.isHidden === false && val?.type !== 'list'
      }
      return val?.isHidden === false
    })
    let listData = filteredTags?.map((val: any) => ({value: val?._id, label: val?.name}))

    setTags(listData)
  }, [tagslist])

  return (
    <>
      {AddTagPopup}
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-700px'
        className='vh-100'
        show={show}
        onHide={handleClose}
        scrollabel={'true'}
      >
        <div className='modal-header'>
          <h2>{`${param?.pathname !== '/user-profile/overview' ? 'Add' : 'Update'} User `}</h2>
          <div className='btn btn-icon btn-sm' onClick={handleClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body px-20 py-5 admin_list_modals'>
          <Formik
            initialValues={user}
            validationSchema={UserAccountSchema}
            onSubmit={(val: any) => {
              const values = {
                ...val,
                email: val?.email?.toLowerCase().trim(),
                name: val?.name?.trim(),
                companyName: val?.companyName?.trim(),
                accountManager: val?.accountManager?.value || '',
                sales: val?.sales?.value || '',
                tags: val?.tags.map((item: any) => item?.value)
              }

              if (!values.avatar || values.avatar === 'undefined') {
                values.avatar = ''
              }

              if (values.smsGateway === 'undefined') {
                values.smsGateway = ''
              }

              if (values.mmsGateway === 'undefined') {
                values.mmsGateway = ''
              }
              

              delete values.editting
              if (values.editting) {
                delete values.password
              }
              const finalData = new FormData()
              for (var key in values) {
                finalData.append(key, values[key])
              }
              if (data) {
                dispatch(UpdateUserAccount({_id: data?._id, data: finalData, page}))
                handleClose()
              } else {
                // console.log(finalData, 'OOOOOOOOOOOOOOOOOOOOOOOOOO')
                dispatch(CreateUserAccount(finalData))
                handleClose()
              }
            }}
          >
            {({values, setFieldValue}: any) => (
              <Form>
                <div className='row mb-6'>
                  <label className='col-form-label fw-bold fs-6'>Avatar</label>
                  <div
                    className='image-input image-input-outline w-auto'
                    data-kt-image-input='true'
                  >
                    {typeof values.avatar !== 'object' && values.avatar !== null ? (
                      <img
                        src={
                          values.avatar === '' || values.avatar === 'undefined'
                            ? toAbsoluteUrl('/media/avatars/blank.png')
                            : values.avatar
                        }
                        alt='poster'
                        width={125}
                        height={125}
                      />
                    ) : (
                      <img
                        src={URL.createObjectURL(values.avatar)}
                        alt='poster'
                        width={125}
                        height={125}
                      />
                    )}

                    <label
                      className='btn btn-icon btn-circle btn-color btn-active-color-primary w-25px h-25px bg-body shadow'
                      data-kt-image-input-action='change'
                      data-bs-toggle='tooltip'
                      data-bs-dismiss='click'
                      title='Change avatar'
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='16'
                        height='16'
                        fill='currentColor'
                        className='bi bi-pencil-fill'
                        viewBox='0 0 16 16'
                      >
                        <path d='M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z' />
                      </svg>
                      <input
                        type='file'
                        name='avatar'
                        onChange={(event: any) => setFieldValue('avatar', event?.target.files[0])}
                        accept='.png, .jpg, .jpeg'
                      />
                    </label>

                    <span
                      className='btn btn-icon btn-circle btn-color btn-active-color-primary w-25px h-25px bg-body shadow'
                      data-kt-image-input-action='remove'
                      data-bs-toggle='tooltip'
                      data-bs-dismiss='click'
                      title='Remove avatar'
                      onClick={(event: any) => setFieldValue('avatar', '')}
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='25'
                        height='25'
                        fill='currentColor'
                        className='bi bi-x'
                        viewBox='0 0 16 16'
                      >
                        <path d='M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z' />
                      </svg>
                    </span>
                  </div>
                  {/* </div> */}
                </div>
                <ErrorMessage name='avatar'>
                  {(msg: string) => <span className='text-danger'>{msg}</span>}
                </ErrorMessage>

                <div className='row'>
                  <div className='col-12'>
                    <label className='col-form-label required fw-bold fs-6' htmlFor='fullName'>
                      Full Name
                    </label>
                    <Field
                      id={'fullName'}
                      className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                      name='name'
                      type='text'
                      onChange={(e: any) => {
                        setFieldValue('name', e.target.value)
                      }}
                    />
                    <ErrorMessage name='name'>
                      {(msg: string) => <span className='text-danger'>{msg}</span>}
                    </ErrorMessage>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-12'>
                    <label className='col-form-label required fw-bold fs-6' htmlFor='companyName'>
                      Company
                    </label>
                    <Field
                      id={'companyName'}
                      className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                      name='companyName'
                      type='text'
                    />
                    <ErrorMessage name='companyName'>
                      {(msg: string) => <span className='text-danger'>{msg}</span>}
                    </ErrorMessage>
                  </div>
                </div>

                <div className='row'>
                  <div className='col-lg-6'>
                    <label className='col-form-label required fw-bold fs-6' htmlFor='email-user'>
                      Email
                    </label>
                    <Field
                      id={'email-user'}
                      className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                      name='email'
                      type='text'
                    />
                    <ErrorMessage name='email'>
                      {(msg: string) => <span className='text-danger'>{msg}</span>}
                    </ErrorMessage>
                  </div>
                  <div className='col-lg-6'>
                    <label className='col-form-label fw-bold fs-6' htmlFor='mobile-user'>
                      Phone
                    </label>
                    <Field
                      id={'mobile-user'}
                      className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                      name='mobile'
                      type='text'
                    />
                    <ErrorMessage name='mobile'>
                      {(msg: string) => <span className='text-danger'>{msg}</span>}
                    </ErrorMessage>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-lg-6'>
                    <label className='col-form-label  fw-bold fs-6' htmlFor='website-user'>
                      Website
                    </label>
                    <Field
                      id={'website-user'}
                      className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                      name='website'
                      type='text'
                    />
                    <ErrorMessage name='website'>
                      {(msg: string) => <span className='text-danger'>{msg}</span>}
                    </ErrorMessage>
                  </div>
                  <div className='col-lg-6'>
                    <label className='col-form-label required fw-bold fs-6' htmlFor='industry'>
                      Industry
                    </label>
                    <Select
                      options={IndustryOptions}
                      value={{value: values?.industry, label: values?.industry}}
                      onChange={(e: any) => setFieldValue('industry', e.value)}
                    />
                    {/* <select
                      value={values?.industry}
                      name='industry'
                      onChange={(e: any) => setFieldValue('industry', e.target.value)}
                      className='form-select form-select-solid form-select-lg'
                    >
                      <option value=''>Select Industry</option>
                      {IndustryOptions?.map((key) => (
                        <option key={key} value={key}>
                          {key}
                        </option>
                      ))}
                    </select> */}
                    <ErrorMessage name='industry'>
                      {(msg: string) => <span className='text-danger'>{msg}</span>}
                    </ErrorMessage>
                  </div>
                </div>

                <div className='row'>
                  <div className='col-lg-6'>
                    <label className='col-form-label fw-bold fs-6' htmlFor='smsGateway'>
                      SMS Gateway
                    </label>
                    <Select
                      options={providerList?.filter((it: any) => (it.type === 'sms') || (it.type === 'default'))}
                      value={{value: values?.smsGateway, label: values?.smsGateway}}
                      onChange={(e: any) => setFieldValue('smsGateway', e.value)}
                    />
                    <ErrorMessage name='smsGateway'>
                      {(msg: string) => <span className='text-danger'>{msg}</span>}
                    </ErrorMessage>
                  </div>

                  <div className='col-lg-6'>
                    <label className='col-form-label fw-bold fs-6' htmlFor='mmsGateway'>
                      MMS Gateway
                    </label>
                    <Select
                      options={providerList?.filter((it: any) => (it.type === 'mms') || (it.type === 'default'))}
                      value={{value: values?.mmsGateway, label: values?.mmsGateway}}
                      onChange={(e: any) => setFieldValue('mmsGateway', e.value)}
                    />
                    <ErrorMessage name='mmsGateway'>
                      {(msg: string) => <span className='text-danger'>{msg}</span>}
                    </ErrorMessage>
                  </div>
                </div>

                <label className='col-form-label fw-bold fs-6' htmlFor='accountType'>
                  Account Type
                </label>
                <Select
                  options={AccountTypeOptions}
                  value={{value: values?.accountType, label: values?.accountType}}
                  onChange={(e: any) => setFieldValue('accountType', e.value)}
                />
                <ErrorMessage name='accountType'>
                  {(msg: string) => <span className='text-danger'>{msg}</span>}
                </ErrorMessage>

                {!values.editting && (
                  <>
                    <label className='col-form-label required fw-bold fs-6' htmlFor='password-user'>
                      Password
                    </label>
                    <div className='password-wrap'>
                      <Field
                        id={'password-user'}
                        className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                        name='password'
                        type={passwordType.password ? 'password' : 'text'}
                      />
                      <span
                        className='svg-icon svg-icon-3'
                        onClick={() => {
                          setPasswordType({...passwordType, password: !passwordType.password})
                        }}
                      >
                        {passwordType.password ? (
                          <i className='bi bi-eye-fill'></i>
                        ) : (
                          <i className='bi bi-eye-slash-fill'></i>
                        )}
                      </span>
                    </div>
                    <ErrorMessage name='password'>
                      {(msg: string) => <span className='text-danger'>{msg}</span>}
                    </ErrorMessage>
                  </>
                )}

                {GeneralDataOFLoginUser()?.isWhiteLabelUser === false && (
                  <>
                    <label className='col-form-label  fw-bold fs-6'>Account ID</label>
                    <Select
                      options={accountIdList?.map((key: any) => ({
                        value: key?._id,
                        label: key?.companyName,
                      }))}
                      onChange={(e: any) => setFieldValue('accountId', e.value)}
                      value={
                        values?.accountId !== ''
                          ? {
                              value: values?.accountId,
                              label: accountIdList?.find(
                                (key: any) => key?._id === values?.accountId
                              )?.companyName,
                            }
                          : {value: '', label: 'Select Account ID'}
                      }
                    />
                    {/* <select
                      value={values?.accountId}
                      name='accountId'
                      onChange={(e: any) => setFieldValue('accountId', e.target.value)}
                      className='form-select form-select-solid form-select-lg'
                    >
                      {accountIdList?.map((key: any, index: any) => {
                        return <option value={key?._id}>{key?.companyName}</option>
                      })}
                    </select> */}
                  </>
                )}
                {accountIdList?.find((key: any) => key?._id === values.accountId)?.companyName ===
                  'cellcast' && (
                  <>
                    <label className='col-form-label  fw-bold fs-6'>Account Manager</label>

                    <Select
                      onInputChange={(e: any) => setPageSearch({...page, search: e})}
                      placeholder={'Select Account Manager'}
                      options={[
                        {value: '', label: 'select account manager'},
                        ...stafflist?.items
                          ?.filter((key: any) => key?.role === 'accountManager')
                          ?.map((val: any) => ({value: val?._id, label: val?.name})),
                      ]}
                      onChange={(e: any) => setFieldValue('accountManager', e)}
                      // value={
                      //   values?.accountManager !== ''
                      //     ? stafflist?.items?.map(
                      //         (key: any) =>
                      //           key?._id === values?.accountManager && {
                      //             value: key?._id,
                      //             label: key?.name,
                      //           }
                      //       )
                      //     : {value: '', label: 'Select Account Manager'}
                      // }
                      // value={{
                      //   value: values?.accountManager,
                      //   label: stafflist?.items?.find(
                      //     (key: any) => key?._id === values?.accountManager
                      //   )?.name,
                      // }}
                    />
                    {/* <Field
                      as='select'
                      name='accountManager'
                      className='form-select form-select-solid form-select-lg'
                    >
                      <option value=''>select</option>

                      {stafflist?.items?.map(
                        (key: any) =>
                          key?.role == 'accountManager' && (
                            <option key={key?._id} value={key?._id}>
                              {key?.name}
                            </option>
                          )
                      )}
                    </Field> */}
                    <label className='col-form-label  fw-bold fs-6'>SALES</label>
                    <Select
                      placeholder='Select Sales'
                      onInputChange={(e: any) => setPageSearch({...page, search: e})}
                      options={[
                        {value: '', label: 'select account manager'},
                        ...stafflist?.items
                          ?.filter(
                            (key: any) => key?.role === 'staffAdmin' || key?.role === 'sales'
                          )
                          ?.map((val: any) => ({value: val?._id, label: val?.name})),
                      ]}
                      onChange={(e: any) => setFieldValue('sales', e)}
                      value={values?.sales?.value
                          ? values?.sales
                          : {value: '', label: 'Select sales'}
                      }
                    />
                    {/* <Field
                      as='select'
                      name='sales'
                      className='form-select form-select-solid form-select-lg'
                    >
                      <option value=''>select</option>

                      {stafflist?.items?.map(
                        (key: any) =>
                          (key?.role == 'sales' || key?.role == 'staffAdmin') && (
                            <option key={key?._id} value={key?._id}>
                              {key?.name}
                            </option>
                          )
                      )}
                    </Field> */}
                  </>
                )}
                <div className='row mb-6'>
                  <div className='col-12'>
                    <label className=' col-form-label  fw-bold fs-6'>Tags</label>
                    <div className='row'>
                      <Select
                        value={values?.tags ?? []}
                        components={{MenuList}}
                        isMulti
                        className='react-tags-selectbox'
                        options={tags}
                        onChange={(e: any) => setFieldValue('tags', e)}
                      />
                    </div>
                  </div>
                </div>

                <div className='row mb-6'>
                  <div className='col-12'>
                    <label className=' col-form-label  fw-bold fs-6'>Feature</label>
                    <div className='row'>
                      {SelectFeature?.map((key: any, index: any) => {
                        return (
                          <div
                            key={index}
                            className='col-6 form-check form-check-custom form-check-solid mt-2 px-3'
                          >
                            <input
                              className='form-check-input'
                              type='checkbox'
                              id='inlineCheckbox1'
                              name='features'
                              value={key}
                              checked={values.features?.includes(key)}
                              onChange={(e: any) => {
                                if (values.features?.includes(e.target.value)) {
                                  let data = [...values?.features]
                                  let index = values.features?.indexOf(e.target.value)
                                  console.log(index, e.target.value, ')))))))))))))))))))', data)

                                  data?.splice(index, 1)
                                  console.log(index, e.target.value, ')))))))))))))))))))', data)
                                  setFieldValue('features', data)
                                } else {
                                  setFieldValue('features', [...values.features, e.target.value])
                                }
                              }}
                            />
                            <label className='form-check-label fw-bold' htmlFor='inlineCheckbox1'>
                              {key}
                            </label>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </div>

                <div className='d-flex col-xl-12 col-sm-12'>
                  <div className='w-100 '>
                    <div className=''>
                      <label className=' col-form-label required fw-bold fs-6'>Role</label>
                    </div>

                    <div>
                      <div className='fv-row mb-10'>
                        <div className='form-check form-check-custom form-check-solid mb-2'>
                          <input
                            className='form-check-input'
                            type='radio'
                            value={'owner'}
                            id='flexRadioChecked'
                            name='role'
                            checked={values?.role === 'owner'}
                            onChange={(e: any) => {
                              if (values?.role === 'owner') {
                                setFieldValue('role', '')
                              } else {
                                setFieldValue('role', e.target.value)
                              }
                            }}
                          />
                          <label
                            className='form-check-label'
                            htmlFor='kt_modal_update_role_option_0'
                          >
                            <div className='fw-bolder card-label fs-5 '>owner</div>
                            <div className='text-gray-600'>
                              'Best for business owners and company administrators'
                            </div>
                          </label>
                        </div>
                      </div>
                      <div className='separator separator-dashed my-5'></div>
                    </div>
                  </div>
                </div>

                <ErrorMessage name='role'>
                  {(msg: string) => <span className='text-danger'>{msg}</span>}
                </ErrorMessage>

                <div className='row'>
                  <div className='col-12'>
                    <label className='col-form-label  fw-bold fs-6' htmlFor='notes'>
                      Default Coupon Code
                    </label>
                    <Field
                      id={'defaultCoupon'}
                      className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                      name='defaultCoupon'
                      type='input'
                    />
                    <ErrorMessage name='defaultCoupon'>
                      {(msg: string) => <span className='text-danger'>{msg}</span>}
                    </ErrorMessage>
                  </div>
                </div>

                <div className='row'>
                  <div className='col-12'>
                    <label className='col-form-label  fw-bold fs-6' htmlFor='notes'>
                      Notes
                    </label>
                    <Field
                      id={'notes'}
                      className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                      name='notes'
                      type='text'
                    />
                    <ErrorMessage name='notes'>
                      {(msg: string) => <span className='text-danger'>{msg}</span>}
                    </ErrorMessage>
                  </div>
                </div>

                <div className='modal-footer d-flex justify-content-center'>
                  <div id='kt_drawer_chat_close'>
                    <button
                      className='btn btn-md gray_bg_purple'
                      type='button'
                      onClick={handleClose}
                    >
                      Cancel
                    </button>
                  </div>

                  <button type='submit' className='btn btn-primary ml-2'>
                    Save
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
    </>
  )
}

export default React.memo(CreateUserAccountPopup)
